"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBriefCase = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconBriefCase = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsx)("svg", _objectSpread(_objectSpread({
    width: "40",
    height: "37",
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M39.9764 8.13917C39.9764 6.93553 39.015 5.95477 37.8314 5.95477H26.6565V3.01768C26.6565 1.35451 25.328 0.00171501 23.6948 0.00171501L16.3035 0C14.6703 0 13.3419 1.3528 13.3419 3.01597V5.95305L2.16696 5.95477C0.983302 5.95477 0.0218886 6.93381 0.0218886 8.13746L0 18.5279C0 18.8657 0.188576 19.1726 0.486591 19.3201C0.941199 19.5447 1.41094 19.7522 1.88072 19.9579V34.0947C1.88072 35.2983 2.84213 36.2791 4.02578 36.2791H35.9742C37.1562 36.2791 38.1193 35.3 38.1193 34.0947V19.7454C38.6008 19.5191 39.0773 19.2842 39.5403 19.0356C39.8232 18.883 40.0017 18.583 40 18.2572L39.9764 8.13917ZM15.0659 3.01768C15.0659 2.32157 15.6215 1.75745 16.3034 1.75745H23.6934C24.3652 1.75745 24.931 2.33527 24.931 3.01768V5.95477H15.0643L15.0659 3.01768ZM36.3933 34.093C36.3933 34.321 36.1963 34.5216 35.9724 34.5216H4.02566C3.79836 34.5216 3.60474 34.3261 3.60474 34.093V20.6523C7.35772 22.0549 11.5504 22.8967 16.1214 23.1556V24.373C16.1214 25.256 16.8269 25.9744 17.694 25.9744H22.3039C23.171 25.9744 23.8765 25.256 23.8765 24.373V23.1419C28.5083 22.8555 32.7009 21.9657 36.3931 20.4911L36.3933 34.093ZM17.8456 24.2204V21.3074H22.1526V24.2204H17.8456ZM23.8766 21.3776V21.1547C23.8766 20.27 23.1711 19.5516 22.304 19.5516H17.6941C16.827 19.5516 16.1216 20.27 16.1216 21.1547V21.3965C10.7221 21.081 5.88115 19.9357 1.72601 17.9724L1.74622 8.13767C1.74622 7.9062 1.93984 7.70902 2.16714 7.70902H37.8315C38.0588 7.70902 38.2524 7.90448 38.2524 8.13938L38.2726 17.7222C34.2183 19.802 29.3757 21.0245 23.8771 21.3777L23.8766 21.3776Z",
      fill: color
    }, void 0)
  }), void 0);
});